import { render, staticRenderFns } from "./PersonaTelefonoForm.vue?vue&type=template&id=70dbe2ce&scoped=true"
import script from "./PersonaTelefonoForm.vue?vue&type=script&lang=js"
export * from "./PersonaTelefonoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dbe2ce",
  null
  
)

export default component.exports